import React from 'react';
import Navbar from './Navbar';
import BreadCrumb from './BreadCrumb';
import Footer from './Footer';
import Download from './Download';
import Newsletter from './Newsletter';
import { FaArrowRight } from 'react-icons/fa';

const Terms = () => {
    return (
        <>
            <Navbar />
            <BreadCrumb />
            <div className="about-content" style={{ padding: '30px', backgroundColor: '#e7e7e7' }}>
                <section className="about-section mission">
                    <h1>Terms & Conditions</h1>

                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        These Terms and Conditions ("Terms") constitute a legally binding agreement between you ("User,"
                        "Trader," "You") and RISEFX Capital Limited ("Company," "We," "Us," "Our"). By using our services,
                        registering an account, or accessing our website or trading platform, you agree to these Terms in
                        full.

                    </p>

                    <h3>1. Eligibility</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            1.1 You must be at least 18 years old or of legal age in your jurisdiction.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            1.2 You must not be a citizen of or resident in any jurisdiction where access to our services is
                            restricted or illegal.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            1.3 You warrant that you are not violating any laws or regulations applicable to you by using our
                            services.
                        </h4>
                    </p>

                    <h3>2.  Account Registration & Management</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            2.1 You agree to provide truthful, accurate, and complete registration information.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            2.2 You are solely responsible for maintaining the confidentiality of your login credentials.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            2.3 You must notify us immediately if you suspect any unauthorized use of your account.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            2.4 We reserve the right to approve or reject any registration without explanation.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            2.5 Each user is allowed only one account unless written permission is granted.
                        </h4>

                    </p>

                    <h3>3. Account Funding and Withdrawals</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            3.1	Funds must be deposited via approved payment channels listed on the platform.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            3.2	Withdrawals will only be processed to the verified account holder using the original payment method.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            3.3	All transactions are subject to AML/KYC compliance and may be delayed pending verification.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            3.4	Fees, charges, or commissions will be clearly displayed and may vary based on services used.
                        </h4>

                    </p>

                    <h3>4. Trading Services</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            4.1	Our platform offers trading in various financial instruments: forex, crypto, commodities, indices, stocks, and CFDs.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            4.2	Market prices are sourced from trusted liquidity providers; however, we do not guarantee real- time accuracy or uptime.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            4.3	Trading services may be interrupted for maintenance, and we are not liable for downtime or order execution issues arising from such interruptions.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            4.4	Leverage, margin requirements, and trading conditions are subject to change without prior notice.
                        </h4>

                    </p>

                    <h3>5. Prohibited Trading Practices</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            5.1	You agree NOT to engage in any of the following:

                            <ul style={{ marginLeft: '40px' }}>
                                <li>Market manipulation (e.g., spoofing, layering)</li>
                                <li>Front-running</li>
                                <li>Insider trading </li>
                                <li>Quote stuffing</li>
                                <li>Use of unauthorized trading software or bots  </li>
                                <li>Latency arbitrage</li>
                            </ul>
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            5.2	We reserve the right to void, cancel, or reverse trades that violate these rules or seem suspicious.
                        </h4>

                    </p>

                    <h3>6. No Scalping Policy</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            6.1 Definition of Scalping
                            <ul style={{ marginLeft: '40px' }}>
                                <li>Scalping is defined as placing and closing a position within a short time period (typically seconds to minutes) to exploit minor price movements.</li>
                            </ul>
                        </h4>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            6.2 Prohibited Scalping Behavior
                            <ul style={{ marginLeft: '40px' }}>
                                <li>Opening and closing trades within 2 minutes</li>
                                <li>Exceeding 25% of all trades without prior approval</li>
                                <li>Using automated trading systems designed for microsecond trades</li>
                                <li>Executing trades based on latency arbitrage</li>
                                <li>Exploiting system bugs, slippage, or price lag</li>
                                <li>Operating multiple accounts to bypass scalping restrictions</li>
                            </ul>
                        </h4>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            6.3 Monitoring and Detection
                            <ul style={{ marginLeft: '40px' }}>
                                <li>We monitor trade timestamps, trade volume, and IP addresses.</li>
                                <li>We may use automated tools and algorithms to detect scalping behavior.</li>
                            </ul>
                        </h4>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            6.4 Consequences of Violations
                            <ul style={{ marginLeft: '40px' }}>
                                <li>Warning and review of activity</li>
                                <li>Trade cancellation or reversal</li>
                                <li>Forfeiture of profits derived from prohibited trades</li>
                                <li>Suspension or permanent termination of account</li>
                                <li>Legal action for fraudulent or abusive behavior</li>
                            </ul>
                        </h4>
                    </p>

                    <h3>7. Leverage and Margin Policy</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            7.1 Users are required to maintain a minimum margin level as specified on the platform.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            7.2 Positions may be closed automatically if margin drops below required thresholds.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            7.3 Margin levels, leverage, and liquidation rules may change based on market volatility.
                        </h4>
                    </p>

                    <h3>8. AML & KYC Compliance</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            8.1  You agree to comply with all applicable anti-money laundering and anti-terrorism financing laws.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            8.2  We may request documentation to verify identity, address, source of funds, and trading purpose.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            8.3 Failure to provide requested documents may result in account suspension or rejection of transactions.
                        </h4>
                    </p>

                    <h3>9. Privacy Policy & Data Use</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            9.1  We collect and process personal data according to our Privacy Policy.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            9.2 We implement industry-standard security to protect user data, but we cannot guarantee absolute security.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            9.3 We do not sell or lease user data to third parties without consent, except where required by law.
                        </h4>
                    </p>

                    <h3>10. Intellectual Property</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            10.1  All content, trademarks, and platform code are the exclusive property of RISEFX.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            10.2  Users are granted a limited, non-transferable, non-exclusive license to use the platform for trading purposes only.
                        </h4>
                    </p>

                    <h3>11. Risk Disclosure</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            11.1  Trading financial instruments involves significant risk of loss and is not suitable for all investors.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            11.2   Past performance is not indicative of future results.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            11.3  You may lose more than your initial deposit.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            11.4  You should only trade with funds you can afford to lose.
                        </h4>
                    </p>

                    <h3>12. Limitation of Liability</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            12.1  We are not liable for:
                            <ul style={{ marginLeft: '40px' }}>
                                <li>Losses arising from internet failure, system outages, or market disruption</li>
                                <li>Errors in price feeds or platform delays</li>
                                <li>Unauthorized access to your account due to your negligence</li>
                            </ul>
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            12.2   Our total liability shall not exceed the amount you have paid us in the last 6 months.
                        </h4>
                    </p>

                    <h3>13. Force Majeure</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            We are not liable for delays or failure in performance resulting from events beyond our reasonable control, including but not limited to war, natural disasters, cyberattacks, or government intervention.
                        </h4>
                    </p>

                    <h3>14. Account Termination</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            14.1  We reserve the right to terminate any user account without notice if:
                            <ul style={{ marginLeft: '40px' }}>
                                <li>Terms are violated</li>
                                <li>Activity is deemed fraudulent or abusive</li>
                                <li>Compliance issues arise</li>
                            </ul>
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            14.2  Users may request account closure at any time, subject to clearing all balances.
                        </h4>
                    </p>

                    <h3>15. Dispute Resolution</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            15.1  Any disputes shall first be attempted to be resolved amicably.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            15.2  If unresolved, the dispute shall be referred to binding arbitration in UAE.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            15.3  The governing law shall be the laws of UAE.
                        </h4>
                    </p>

                    <h3>16. Amendments</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            We reserve the right to update these Terms at any time. Users will be notified via platform notice or email. Continued use constitutes acceptance of updated Terms.
                        </h4>
                    </p>

                </section>
            </div>
            <Download />
            <Newsletter />
            <Footer />
        </>
    );
}

export default Terms;
